<template lang="html">
  <section class="text-legal pad-sec" v-html="$t('datos_seguros')">
  </section>
</template>

<script lang="js">
export default {
  name: 'datos-seguros'
}
</script>

<style scoped>
ul li {
  list-style: disc;
  margin-left: 20px;
}

b {
  font-weight: bold;
}</style>



// WEBPACK FOOTER //
// src/components/views/datos-seguros.vue